/**
 * @generated SignedSource<<aa10696ec6a2d7e4cb588f189ac2382f>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559

import type { ConcreteRequest } from 'relay-runtime';
export type MissedPubSubCommentEventsHandlerQuery$variables = {
  contentId: AGG$Long;
  since: AGG$Long;
};
export type MissedPubSubCommentEventsHandlerQuery$data = {
  readonly quickReload: {
    readonly comments: ReadonlyArray<{
      readonly comment: {
        readonly author: {
          readonly accountId?: string | null | undefined;
        };
        readonly id: string;
        readonly location: {
          readonly type: string;
        };
      };
    }>;
    readonly time: AGG$Long;
  } | null | undefined;
};
export type MissedPubSubCommentEventsHandlerQuery = {
  response: MissedPubSubCommentEventsHandlerQuery$data;
  variables: MissedPubSubCommentEventsHandlerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "since"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "since",
    "variableName": "since"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "time"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "type"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "KnownUser"
},
v7 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "UnknownUser"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MissedPubSubCommentEventsHandlerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "QuickReload",
        "kind": "LinkedField",
        "name": "quickReload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "QuickReloadComment",
            "kind": "LinkedField",
            "name": "comments",
            "plural": true,
            "selections": [
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MissedPubSubCommentEventsHandlerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "QuickReload",
        "kind": "LinkedField",
        "name": "quickReload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "QuickReloadComment",
            "kind": "LinkedField",
            "name": "comments",
            "plural": true,
            "selections": [
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "comment",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
    "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
    "metadata": {},
    "name": "MissedPubSubCommentEventsHandlerQuery",
    "operationKind": "query",
    "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
  }
};
})();

(node as any).hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";

export default node;
